import { useMutation } from '@tanstack/react-query'

// constants
import API from '../../services/api'

// hooks
import useAnalytics from '../helper/useAnalytics'

export default function useSupportEmailMutation() {
    const { track } = useAnalytics()
    return useMutation({
        mutationFn: API.sendSupportEmail,
        onMutate: () => {
            track('support_request_submitted')
        },
    })
}
